module.exports = __webpack_public_path__ + "static/media/img-localizacao-sanpaolo.77049e70.jpg";